import React, { Component }        from 'react';
import {connect}                   from 'react-redux';
import FotoPerfil                  from '../../../container/renderFotoPerfil';
import { GetGruposAlunos,
         GetAdicionarAlunoEquipe,
         SetAdicionarAlunoEquipe } from '../../../actions/grupoAction';
import FlashRetornoNulo            from '../../../container/FlashRetornoNulo';
import FlashCarregando             from '../../../container/FlashCarregando';

import { ActionModal }             from '../../../actions/scopoAction';

class equipe_adicionar_aluno_equipe extends Component {


    constructor(props){

        super(props);
        this.state = {
                      load2         : false,
                      list_id_aluno : [],
                      use_id        : this.props.session.id,
                      tur_id        : this.props.all_equipe_turma.tur_id,
                      dis_id        : this.props.all_equipe_turma.dis_id,
                      disabled      : true
                     }     
               
  }


  componentWillMount() {
   
      this.props.GetAdicionarAlunoEquipe(this.state.tur_id,this.state.dis_id).then((response)=>{
           this.setState({load2: true });
      });
    }


    renderAlunosAdicionarEquipe() {
         
        const adicionarEquipesAlunos = this.props.all_dicionar_aluno;
            if (adicionarEquipesAlunos.length) {
                const lisAlunos = adicionarEquipesAlunos.map((elem, i) => {

                    return <tr key={i}>
                        <td className="text-center">
                            <FotoPerfil width="35" height="35" className="img-rounded" src={elem.use_foto} />
                        </td>
                        <td className="text-center">
                            {elem.use_nome}
                        </td>
                        <td className="text-center hidden-xs">
                            {elem.use_email}
                        </td>
                        <td className="text-center">
                            <input type="checkbox" value={elem.use_id} onClick={this.adicionarAluno.bind(this)} />
                        </td>
                    </tr>
                });

            return  <table className="table table_panel">
                                            <thead>
                                                <tr>
                                                    <th className="text-center">Foto</th>
                                                    <th className="text-center">Nome</th>
                                                    <th className="text-center hidden-xs">Email</th>
                                                    <th className="text-center">Adicionar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {lisAlunos}
                                            </tbody>
                                        </table>;

            
            } else {

                return  <FlashRetornoNulo/>;
            }
            
    }

    adicionarAluno(e) {
    
        const ar = this.state.list_id_aluno;
        if (e.target.checked) {
            ar.push(e.target.value);
        } else {

            ar.filter((elem,index)=> {
                if (elem === e.target.value) {
                    ar.splice(index, 1);
                }
            });

            this.setState({ list_id_aluno: [] });
        }

        this.setState({ list_id_aluno: ar });
        if(this.state.list_id_aluno.length === 0){this.setState({ disabled: true })}else{this.setState({ disabled: false })};

    }

    adicionarAlunosEquipe() {

        const dados = {alu_equ_cod_aluno     : this.state.list_id_aluno,
                        alu_equ_cod_equipe    : this.props.equ_id,
                        alu_equ_cod_professor : this.state.use_id
                        }
        this.props.SetAdicionarAlunoEquipe(dados).then((response) => {
            alert('Ação realizada com sucesso!');
            this.props.GetGruposAlunos(this.props.equ_id);
            this.props.ActionModal(false);
        });
    }

    render() {

        return (
            <div>
            <div className="panel panel-default">
                 <div className="panel-heading"><b>Adicionar aluno da equipe</b></div>
                {!this.state.load2 ? <FlashCarregando/> : this.renderAlunosAdicionarEquipe()}
                <div className="panel-footer clearfix">
                    <button 
                        type      = "button"
                        className = "btn btn-danger btn-sm pull-left"
                        onClick   = {()=>this.props.ActionModal(false)}
                        >Fechar
                    </button>    
                    <button 
                        type      = "button"
                        className = "btn btn-primary btn-sm pull-right"
                        disabled  = {this.state.disabled}
                        onClick   = {this.adicionarAlunosEquipe.bind(this)}>Adicionar
                </button>
                </div>
            </div>
                
            </div>
        );
    }
}
function mapStateToProps(state){

    return {
             session            : state.auth.session,
             all_equipe_turma      : state.equipeReducer.all_equipe_turma,
             all_dicionar_aluno : state.equipeReducer.all_aluno_adicionar_equipe
           }
}

export default connect(mapStateToProps,{ActionModal,GetAdicionarAlunoEquipe,SetAdicionarAlunoEquipe,GetGruposAlunos})(equipe_adicionar_aluno_equipe);





// WEBPACK FOOTER //
// ./src/components/professor/equipe/equipe_adicionar_aluno_equipe.js